import { AxiosPromise } from 'axios';
import * as GamesProvider from '../../providers/games/gamesProvider';

const gamesApiInstance = new GamesProvider.GamesApi();
const gamePassesApiInstance = new GamesProvider.GamePassesApi();

const getGameDetails = (universeIds: number[]): AxiosPromise<
GamesProvider.RobloxWebWebAPIModelsApiArrayResponseRobloxGamesApiModelsResponseGameDetailResponse
> => {
  return gamesApiInstance.v1GamesGet(universeIds, { withCredentials: true });
};

const getGamePasses = (universeId: number, sortOrder?: 'Asc' | 'Desc', limit?: 10 | 25 | 50 | 100, cursor?: string): AxiosPromise<
GamesProvider.RobloxWebWebAPIModelsApiPageResponseRobloxGamesApiModelsResponseGamePassResponse
> => {
  return gamePassesApiInstance.v1GamesUniverseIdGamePassesGet(universeId, sortOrder, limit, cursor);
};

export default {
  getGameDetails,
  getGamePasses
};
